import React, { Component } from 'react';
import { observer } from "mobx-react";
import { observable } from "mobx";

@observer class NavButton extends Component {

  @observable __showPane = false;

  componentDidMount() {
    setTimeout(this.initPane.bind(this), 0)
    window.addEventListener('click', () => this.__showPane = false & this.hidePane());
  }

  initPane() {
    const nav = this.props.nav;
    const {x, y, height} = this.getBounds();
    const REF = this.props.index + '-pane';
    const pane = nav.refs[REF];
    this.pane = pane;
    if(!pane) return;
    pane.setStyle({
      top: y + height + 10,
      left: x
    });
  }

  showPane() {
    this.initPane()
    this.pane.show();
  }

  hidePane() {
    this.pane.hide();
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.__showPane = !this.__showPane;
    if(this.__showPane) this.showPane();
    else this.hidePane()
  }

  getBounds() {
    return this.refs.button.getBoundingClientRect();
  }

  render() {
    return (
      <button ref='button' className="menu-item" onClick={this.handleClick.bind(this)}>
        {this.props.children}
      </button>
    );
  }

}

export default NavButton;



// WEBPACK FOOTER //
// ./src/components/ui/nav/NavButton.js